module.exports = __webpack_public_path__ + "static/media/games.5fb8ca9c.svg";